import api from "../axios";

const getAccountId = () => sessionStorage.getItem("acc_id");

const getPatientId = () => sessionStorage.getItem("_pt_id");

const getLocationId = () => JSON.parse(sessionStorage.getItem("current_loc"))?.id;

export async function linkDevice(data) {
  data.patient_id = getPatientId();
  const response = await api.post(
    `/devices/${getAccountId()}/assign-device/`,
    data
  );
  return response.data;
}

export async function unlinkDevice(data) {
  const response = await api.post(
    `/devices/${getAccountId()}/unlink-device/`,
    data
  );
  return response.data;
}

export async function getAssignedDevices() {
  const response = await api.get(
    `/devices/${getAccountId()}/assigned-devices/${getPatientId()}/`
  );
  return response.data;
}

export async function orderDropship(data) {
  const patient_id = getPatientId();
  const tenantId = getAccountId();

  data.patient_id = patient_id;

  const response = await api.post(
    `/devices/${tenantId}/dropship-orders/`,
    data
  );
  return response.data;
}

export async function getDropshipedDevices({ patientId, locationId }) {
  const tenantId = getAccountId();

  const response = await api.get(`/devices/${tenantId}/dropship-orders/`, {
    params: {
      patient_id: patientId,
      location_id: locationId,
    },
  });

  return response.data;
}

export async function getInternalBulkOrderedDevices({}) {
  const locationId = getLocationId();
  const tenantId = getAccountId();

  const response = await api.get(`/inventory/${tenantId}/bulk-orders/`, {
    params: {
      location_id: locationId,
    },
  });

  return response.data;
}

export async function getOrderedDevices() {
  const response = await api.get(
    `/devices/${getAccountId()}/ordered-devices/${getPatientId()}/`
  );
  return response.data;
}

export async function createTicket(data) {
  const patient_id = getPatientId();
  data.patient_id = patient_id;
  const response = await api.post(
    `/devices/${getAccountId()}/tenical-support-ticket/`,
    data
  );
  return response.data;
}

export async function getTickets() {
  const response = await api.get(
    `/devices/${getAccountId()}/tickets/${getPatientId()}/`
  );
  return response.data;
}

export async function createTicketEvent(ticketId, data) {
  const response = await api.post(
    `/devices/${getAccountId()}/tickets/${ticketId}/events/`,
    data
  );
  return response.data;
}

export async function getTicketEvents(ticketId) {
  const response = await api.get(
    `/devices/${getAccountId()}/tickets/${ticketId}/events/`
  );
  return response.data;
}
